export function loadExternalScript(src) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.onload = () => {
        // console.log('Script loaded successfully');
    };
    script.onerror = () => {
        // console.error('Script load error');
    };
    document.head.appendChild(script);
}
export function routerLink(url, targets = false,filename) {
    const link = document.createElement('a');
    link.href = url;
    link.style.display = 'none';
    link.target = targets ? '_blank' : "_self";
    if (filename){
        link.download = filename
    }
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
        document.body.removeChild(link);
    }, 0);
}
export function isNumber(value) {
    const reg = /^[0-9]*$/
    return reg.test(value)
}
export function setPageSeo(title, keyword, description) {
    document.title = title + "_CF40";
    document.querySelector('meta[name="keywords"]').setAttribute('content', keyword);
    document.querySelector('meta[name="description"]').setAttribute('content', description);
}
export function handleTree(data, id, parentId, children, filed = "", filedValue) {
    let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
    };

    var childrenListMap = {};
    var nodeIds = {};
    var tree = [];

    for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
            childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
    }

    for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
            tree.push(d);
        }
    }

    for (let t of tree) {
        adaptToChildrenList(t);
    }

    function adaptToChildrenList(o) {
        if (filed) {
            o[filed] = filedValue;
        }
        if (childrenListMap[o[config.id]] !== null) {
            o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
            for (let c of o[config.childrenList]) {
                adaptToChildrenList(c);
            }
        }
    }
    return tree;
}
export function createYears(startYear, endYear) {
    let arr = [];
    endYear = endYear && isNumber(endYear) ? endYear : this.$moment().year();
    for (let i = startYear; i <= endYear; i++) {
        arr.push(i);
    }
    return arr;
}
